import { call, put } from 'redux-saga/effects';
import { photoCapturePhotoUploadSuccessAction, photoCaptureDataFailureAction } from '../actions';
import { PhotoCapturePhotoUploadService } from '../services';
import { PhotoCaptureServiceHeader } from '../constants';
export function* photoCapturePhotoUploadSaga(action, photoCapturePhotoUploadService = PhotoCapturePhotoUploadService.getInstance()) {
    const { contextId, coCode, sourceName } = action.payload;
    try {
        const response = yield call({
            context: photoCapturePhotoUploadService,
            fn: photoCapturePhotoUploadService.photoCapturePhotoUploadData
        }, contextId, coCode, Object.assign(Object.assign({}, PhotoCaptureServiceHeader), { sourceName }));
        yield put(photoCapturePhotoUploadSuccessAction(response.result));
    }
    catch (error) {
        yield put(photoCaptureDataFailureAction(error.toString()));
    }
}
//# sourceMappingURL=photoCapturePhotoUploadSaga.js.map